/***
**Module Name: Company details
 **File Name :  Company.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains compant tables details.
 ***/

import React, { useState, useEffect, useContext } from "react";


import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
import Sidebar from "../../../components/dashboard/sidebar";
import tmdbApi from "../../../api/tmdbApi";
import { useHistory, Link, useLocation } from "react-router-dom";
import moment from "moment";
import { contentContext } from "../../../context/contentContext";
import SessionPopup from "../../SessionPopup"
import DataTable from 'react-data-table-component';

import Loader from "../../../components/loader";
import parse from "react-html-parser";
let { lambda, appname } = window.app;



const Reports = () => {
    const history = useHistory();
    const { state } = useLocation();
    const { search } = state || {};
    // const [toggle, setToggle] = useState(false);
    const [content, setContent] = useState("");
    const [success, setSuccess] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);
    const [deleteQuiz, setdeleteQuiz] = useState(false);
    const [quizId, setQuizId] = useState(null);
    // const [data, setData] = useState([]);
    const [itemsPerPage, setitemsPerPage] = useState(10);
    const [tableErrMsg, setTableErrMsg] = useState(false);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [loaderEnable, setLoaderEnable] = useState(false);
    const [contentLoaded, setcontentLoaded] = useState(false);

    const [searchvalue, setSearch] = useState(null);
    const [quizzes, setQuizzes] = useState([]);
    const [reports, setReports] = useState({});
    const [quizInfo, setQuizInfo] = useState(null);
    const [showReport, setshowReport] = useState(false);

    const handleClosePopup = () => setShowPopup(false);

    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    const [sortDirection, setSortDirection] = useState('asc');

    const [imageCloudfront, setImg] = useState('');

    const [popup, setShowPopup] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, processObject, sortTableAlpha, arrow, sortTableByDate, userData, companysearch, setCompanySearch, companyadvSearch, setCompanyAdvSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, setActiveMenuObj, GetTimeActivity } = useContext(contentContext)

    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu == "Client Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].submenus && validateObj[0].submenus[1] && validateObj[0].submenus[1].dashboard


    const getSerialNumber = (index) => {
        // Serial number calculation: it continues from the last serial number of the previous page
        return (currentPageNew - 1) * rowsPerPage + index + 1;
    };


    const columns = [
        {
            name: 'Sl No',
            selector: (row, index) => {
                return getSerialNumber(index);
            },
        },
        {
            name: 'Quiz Name',
            selector: row => row?.name ?? "",
          //  sortable: true,
        },
        {
            name: 'Participants',
            selector: row => row?.participants ?? 0,
           // sortable: true,
        },

        {
            name: 'Quiz Type',
            selector: row => row?.quizType ?? "",
          //  sortable: true,
        },

        // {
        //     name: 'Started On',
        //     selector: row => row?.startDate,
        //     cell: (props) => props?.startDate ? moment.utc(props?.startDate).format('DD MMM YYYY, h:mm A') : "",
        //     sortable: true,
        //     // sortFunction: (a, b) => moment(a.created).diff(b.created),
        // },
        // {
        //     name: 'Ended On',
        //     selector: row => row?.endDate,
        //     cell: (props) => props?.endDate ? moment.utc(props?.endDate).format('DD MMM YYYY, h:mm A') : "",
        //     sortable: true,
        //     // sortFunction: (a, b) => moment(a.created).diff(b.created),
        // },


        {
            name: 'Report',
            cell: (props) =>
                <a onClick={(e) => handleReport(e, props)} className="btn btn-sm btn-soft-primary"> View Report</a>
            ,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];


    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }

    }, [window.site]);
    const keyForRerender = `${rowsPerPage}_${data?.length}`;

    const handlePageChange = (page) => {
        setCurrentPage(page);

    };

    const handlePerRowsChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
    };


    const handleReport = (e, quiz) => {
        setQuizInfo(quiz)
        GetReportsInfo(quiz?.quizid)
        setshowReport(true)
    };


    useEffect(() => {

        if (!localStorage.getItem("token")) {
            history.push("/admin");
        }
        GetQuizInfo()

    }, []);

    const GetQuizInfo = async () => {
        setIsLoading(true)
        try {
            const response = await tmdbApi.quizInfoCompeleted();
            setQuizzes(response?.result);
            setIsLoading(false)
            setcontentLoaded(true)
        } catch {
            console.log("error");
            setcontentLoaded(true)
        }
    };


    const handleSearch = async (e) => {
        setIsLoading(true)
        try {
            if (searchvalue != null && searchvalue != "") {
                const response = await tmdbApi.quizReportsSearchInfo(searchvalue);
                setQuizzes(response?.result);
                setIsLoading(false);
            }

        } catch {
            console.log("error");
        }
    }



    const handleChange = (e) => {
        setSearch(e.target.value)
    }

    const clearSearch = () => {
        setSearch(null);
        GetQuizInfo()
    }


    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No content found</p>
                </div> </div>
        )
    }



    const GetReportsInfo = async (quizId) => {
        setIsLoading(true)
        try {
            const response = await tmdbApi.reportsInfo(quizId);
            // const transformedData = transformData(response?.result);
            setReports(response?.result);
            setcontentLoaded(true)
            setIsLoading(false)
        } catch {
            console.log("error");
            setcontentLoaded(true)
        }
    };


    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                {isLoading ? <Loader /> : <div className="quiz-page main-content user-management clients company quiz-section-page">

                    <div className="page-content">
                        <div className="container-fluid">



                            <div className="row mb-4 breadcrumb">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title">REPORTS</h4>

                                        </div>
                                        <div>
                                            {showReport && <a onClick={(e) => setshowReport(!showReport)} className="btn btn-primary">back</a>}
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="row table-data">
                                <div className="col-12">
                                    <div className="card">

                                        {showReport ?
                                            <div className="card-body">
                                                <div className="row mb-2">

                                                    <div className="col-sm-10">
                                                            <h4>{quizInfo?.name}</h4>
                                                    </div>
                                                    <div className="col-sm-2">
                                                        <div className="report_right">
                                                            {quizInfo?.quizType === "Self Assessment" ? <div className="tooltip2" data-text="Self Assessment">
                                                                    <span className="material-symbols-outlined self_assessment "> list_alt_check </span>
                                                                </div> : <div className="tooltip2" data-text="Competitive">
                                                                    <span className="material-symbols-outlined competitive"> workspace_premium </span>
                                                                </div>}
                                                                <span className="users"><span className="material-symbols-outlined icon"> group </span><span className="num">{quizInfo?.participants}</span></span>
                                                            {/* <p>Type: {quizInfo?.quizType}</p> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="reports_block">
                                                    <div className="accordion" id="accordionExample">
                                                        {contentLoaded && reports && Object.keys(reports).length > 0 && Object.keys(reports)?.map((item, key) => {

                                                            console.log('item', reports[item])
                                                            const actualAnswer = reports[item]?.actualanswer;
                                                            let answer = Object.keys(reports[item]?.answers);
                                                            const hasActualAnswer = Object.keys(reports[item]?.answers || {}).includes(actualAnswer);
                                                            return (
                                                                <div className="accordion-item" key={key}>
                                                                    <h2 className="accordion-header" id="headingOne">
                                                                        <button className="accordion-button fw-medium" type="button" data-bs-toggle="collapse" data-bs-target={"#collapse" + key} aria-expanded="true" aria-controls={"collapse" + key}>
                                                                            {reports[item]?.question}
                                                                        </button>
                                                                    </h2>
                                                                    <div id={"collapse" + key} className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                                        <div className="accordion-body">
                                                                            <p>{parse(reports[item]?.description)}</p>
                                                                            <div className="img_block" >
                                                                            {reports[item]?.images && reports[item]?.images?.length > 0 && reports[item]?.images?.map((imageitem, index) => {
                                                                               let imageFile = imageitem?.filepath.replace(/ /g, "%20");
                                                                                return (
                                                                                   

                                                                                    <img src={imageCloudfront + imageFile+ `?auto=compress,format&width=110`} className="img" alt="" key={index} />
                                                                                )
                                                                            })}
                                                                        </div>
                                                                           
                                                                           

                                                                            <table className="table table-bordered align-middle nowrap">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th scope="col">No</th>
                                                                                       
                                                                                        <th scope="col">Answer</th>
                                                                                        <th scope="col">Count</th>
                                                                                        <th scope="col">Percentage</th>

                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {reports[item]?.answers && Object.keys(reports[item]?.answers).length > 0 && answer?.map((aitem, index) => {
                                                                                        return (<tr key={index}>
                                                                                            <td scope="row">{index + 1}</td>
                                                                                          
                                                                                            <td>

                                                                                            {aitem === reports[item]?.actualanswer ? (
                                                                                            <span className="text-success">{aitem}</span>
                                                                                            ) : (
                                                                                                <span>{aitem}</span>
                                                                                            )}
                                                                                            </td>
                                                                                            <td>{reports[item]?.answers[aitem]?.count}</td>
                                                                                            <td>{reports[item]?.answers[aitem]?.percentage}</td>
                                                                                        </tr>)
                                                                                    })}

                                                                                     {/* Add the "next row" only if there's no actual answer */}
                                                                                    {!hasActualAnswer && (
                                                                                        <tr key="next-row" className="correct-answer">
                                                                                        <td >{Object.keys(reports[item]?.answers).length  + 1}</td>
                                                                                        <td className="correct">
                                                                                            {/* Add any custom content for the extra row */}
                                                                                            {actualAnswer}
                                                                                        </td>
                                                                                        <td>0</td>
                                                                                        <td>0%</td>
                                                                                        </tr>
                                                                                    )}


                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </div>
                                                                </div>)
                                                        })
                                                        }
                                                        {contentLoaded && reports && Object.keys(reports).length == 0 &&
                                                            customNoRecords()}

                                                    </div>
                                                </div>
                                            </div> :

                                            <div className="card-body">
                                                <div className="row mb-2">

                                                    <div className="col-sm-8">
                                                        <div className="search-box mb-2 d-inline-block">

                                                            <div className="position-relative">
                                                                <input type="text" className="form-control" value={searchvalue ? searchvalue : ""} placeholder="Search " onChange={(e) => handleChange(e)} />
                                                                <button className="fill_btn" onClick={(e) => handleSearch(e)} >
                                                                    <span className="material-icons search-icon">search</span>
                                                                </button>
                                                            </div>

                                                            <div className="dataTables_length" id="datatable_length">
                                                                <button className="fill_btn" onClick={(e) => clearSearch(e)}><span
                                                                    className="material-icons-outlined">sync</span>Reset</button>
                                                            </div>

                                                        </div>
                                                        <div className="text-sm-end">

                                                        </div>
                                                    </div>
                                                </div>


                                                <DataTable className="reports_table" key={keyForRerender}
                                                    // title=""
                                                    columns={columns}
                                                    // className="table align-middle table-nowrap table-check"
                                                    keyField='_id'
                                                    data={quizzes}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    responsive
                                                    persistTableHead
                                                    // selectableRowsVisibleOnly
                                                    striped
                                                    // selectableRowsHighlight
                                                    // selectableRows
                                                    subHeaderAlign="right"
                                                    defaultSortField="name"
                                                    subHeaderWra
                                                    noDataComponent={customNoRecords()}
                                                    paginationTotalRows={quizzes?.length}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    paginationPerPage={rowsPerPage}
                                                    paginationDefaultPage={currentPageNew}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}

                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}

                                                //  progressPending={isLoading}
                                                //  progressComponent={<TableLoader />}
                                                />


                                              
                                            </div>
                                        }




                                    </div>
                                </div>


                            </div>


                        </div>
                    </div>






                    <Footer />
                </div>
                }


            </div>
        </>
    );
};

export default Reports;
